// Disable non-changed fields before submit, so only processing new data
export default function() {

  $('.data-collection-content input:not([disabled]), .data-collection-content select:not([disabled]), .data-collection-content textarea:not([disabled])').attr('disabled', true).addClass('temp');

  $('input.new-data[value=true]').each(function() {
    $(this).closest('tr').find('input, select, textarea').attr('disabled', false);
    $(this).closest('.form-group').find('input, select, textarea').attr('disabled', false);
  })

}